import { types, applySnapshot } from 'mobx-state-tree';
import Framework from '@greenville/framework';
import * as constants from '../../../common/constants';
import utils from '../../../common/utils';

const trendsData = types.model('trendsData', {
  bookId: types.maybeNull(types.string),
  date: types.maybeNull(types.string),
  relevantTopicsCount: types.maybeNull(types.number),
  videoSummaryCount: types.maybeNull(types.number),
  questionIntentCount: types.maybeNull(types.number),
  questionSolutionCount: types.maybeNull(types.number),
  questionStepsSolutionCount: types.maybeNull(types.number),
  disLikeCount: types.maybeNull(types.number),
  likeCount: types.maybeNull(types.number)
});

const ChannelsTrends = types
  .model('Trends', {
    data: types.optional(types.array(trendsData), [])
  })
  .actions((self) => ({
    fetch(payload, tenantId) {
      Framework.getEventManager().publish(constants.GET_CHANNELS_TRENDS_DATA, {
        payload,
        tenantId
      });
    },
    setResponse(response) {
      const aggregratedData = utils.fetchChannelsIdWiseData(response?.data);
      const dataToSet = {
        ...response,
        data: aggregratedData
      };
      applySnapshot(self, dataToSet);
      Framework.getEventManager().publish(constants.GET_CHANNELS_TRENDS_MODEL_DATA);
    },
    resetStoreValues() {
      const initialState = [];
      applySnapshot(self.data, initialState);
      Framework.getEventManager().publish(constants.GET_CHANNELS_TRENDS_MODEL_DATA);
    }
  }));

export default ChannelsTrends;
